<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px; cursor: pointer;"
    (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
  <div class="modal-body no-body-scroll">
    <div class="col-md-12">
      <label>Category:</label>
      <input type="text"
        class="form-control input-sm"
        name="categoryName"
        [(ngModel)]="categoryName"
        maxlength="40"
        required>
      </div>
    </div>
  </form>

  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm"
      type="button"
      [disabled]="isSaveClicked || !categoryName?.trim()"
      (click)="save()">
      @if (crudLoading) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
      Save
    </button>
    <button class="btn btn-warning btn-sm"
      type="button"
    (click)="cancel()">Cancel</button>
  </div>
